import { render, staticRenderFns } from "./Pageheader.vue?vue&type=template&id=1a568348&"
import script from "./Pageheader.vue?vue&type=script&lang=ts&"
export * from "./Pageheader.vue?vue&type=script&lang=ts&"
import style0 from "./Pageheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports